export enum ModelName {
	SheetProduct = "sheet-products",
	SheetProductTemplate = "sheet-templates",
	OrderItem = "orders",	
	Project = "projects",
	SheetMaterial = "sheet-materials",
	WaterDrainageMaterial = "waterDrainage-materials",
	User = "users",
	Document = "documents",
	Image = 'images',
	UserAccess = 'userAccess',
	ContactPerson = 'contactPersons',
	WaterDrainageProduct = 'waterDrainageProducts',
	factoryAddresses = "factory-addresses",
	InfastningProduct = "infastningProducts",
	OvrigtProduct = "ovrigtProducts",
	Fastblack = "fastblacks",
	Gables = "gables",
	Holes = "holes",
	Bakkappa = "bakkappas",
	Underbeslag = "underbeslags",
	Company = "companies",
	Skorstenstopp = "skorstenstopps",
	Skorstensranna = "skorstensrannas",
	ProductionPrices = "productionPrices"
}
